/* eslint-disable import/prefer-default-export */
import Big from "big.js";

export const itemTotalDiscount = (item) => Number(Big(itemDiscount(item.unit_price, item.discount_type, item.discount_value)).times(Number(item.quantity)).round(2));

export const itemSubtotal = (item) => {
  const quantity = Number(item.quantity);
  const unitPrice = Number(item.unit_price);
  const discount = itemTotalDiscount(item);
  return Number(Big(quantity).times(unitPrice).minus(discount).round(2));
};

export const orderTotals = (items = [], order = {}) => {
  const filteredItems = items.filter((el) => el._destroy !== true);

  const subtotal = filteredItems.reduce((acc, item) => acc.plus(itemSubtotal(item)), Big(0));
  const orderTotalDiscount = itemDiscount(subtotal, order.discount_type, order.discount_value);

  const tax = filteredItems.reduce((acc, item) => {
    const newItemSubtotal = Big(itemSubtotal(item)).minus(weightedDiscount(item, subtotal, orderTotalDiscount));
    const itemTax = newItemSubtotal.times(Number(item.custom_tax)).div(100);
    return acc.plus(itemTax);
  }, Big(0));

  const newShippingValue = order.shipping_value === '' ? 0 : order.shipping_value;
  const total = subtotal.plus(Number(tax)).plus(Number(newShippingValue)).minus(orderTotalDiscount).round(2);

  return {
    subtotal: Number(subtotal.round(2)),
    discount: 0,
    tax: Number(tax.round(2)),
    shipping_value: newShippingValue,
    total_discount: orderTotalDiscount,
    subtotal_with_discount: Number(subtotal.minus(orderTotalDiscount).round(2)),
    total: Number(total)
  };
};

export const weightedDiscount = (item, subtotal, totalDiscount) => {
  if (Number(subtotal) <= 0) return 0;

  const participationOfProduct = Number(Big(itemSubtotal(item)).div(Number(subtotal)));

  return Number(Big(Number(totalDiscount)).times(participationOfProduct));
};

export const itemDiscount = (amount, discountType, discountVaue) => {
  if (discountType === 'quantity') {
    if (Number(amount) <= Number(discountVaue)) return Number(amount);

    return Number(discountVaue);
  }

  if (discountType === 'percentage') {
    return Number(Big(Number(amount)).times(Number(discountVaue)).div(100).round(2));
  }

  return 0;
};

export const applyDiscounts = (items, order) => {
  const newOrderTotals = orderTotals(items, order);

  return items.map((item) => ({
    ...item,
    global_discount: weightedDiscount(item, newOrderTotals.subtotal, newOrderTotals.total_discount),
    total_discount: itemTotalDiscount(item)
  }));
};
